<div class="container">
  <div class="content" [ngClass]="{ 'full-width': isStaffApp$ | async }">
    <div class="brand">
      @if (isStaffApp$ | async) {
        <button mat-icon-button (click)="toggleSidenav()">
          <mat-icon>menu</mat-icon>
        </button>
      }
      <a href="/"><img src="assets/images/small-logo.png" /></a>
    </div>

    <div class="actions">
      @if ((latestMessages$ | async) && (latestMessages$ | async)!.length > 0) {
        <button mat-icon-button [matMenuTriggerFor]="chatMenu" id="chat-menu">
          <mat-icon>chat</mat-icon>

          @if (
            (unreadMessagesCount$ | async) &&
            (unreadMessagesCount$ | async)! > 0
          ) {
            <span id="unread-notifications">{{
              unreadMessagesCount$ | async
            }}</span>
          }
        </button>
        <mat-menu #chatMenu xPosition="before">
          @for (m of latestMessages$ | async; track m.message.id) {
            <button
              mat-menu-item
              class="message"
              (click)="
                m.thread.orderCard
                  ? goToThreadForOrderCard(
                      m.thread.orderCard!.orderId,
                      m.thread.orderCardId!
                    )
                  : goToThreadForCustomer(m.thread.customerProfileId!)
              ">
              <p class="from">
                @if (isStaffApp$ | async) {
                  {{
                    (
                      m.thread.customerProfile ??
                      m.thread.orderCard?.order?.customerProfile
                    )?.firstName +
                      ' ' +
                      (
                        m.thread.customerProfile ??
                        m.thread.orderCard?.order?.customerProfile
                      )?.lastName
                  }}
                } @else {
                  Staff
                }
                -
                {{
                  m.thread.orderCard
                    ? m.thread.orderCard.order?.name +
                      ' / ' +
                      m.thread.orderCard.label
                    : 'General Chat'
                }}
              </p>
              <div class="message-row">
                <p class="clipped-content">
                  @if (
                    (isStaffApp$ | async)
                      ? !m.message.customerProfileId
                      : !!m.message.customerProfileId
                  ) {
                    <span class="you-indicator">You:&nbsp;</span>
                  }
                  {{ m.message.content }}
                </p>

                @if (
                  (isStaffApp$ | async)
                    ? !!m.message.customerProfileId && !m.message.readAt
                    : !m.message.customerProfileId && !m.message.readAt
                ) {
                  <div class="unread-indicator"></div>
                }
              </div>

              <p class="timestamp">{{ formatSentAt(m.message.sentAt) }}</p>
            </button>
          }
        </mat-menu>
      }

      <button mat-flat-button [matMenuTriggerFor]="userMenu">
        {{ username$ | async }}
        <mat-icon iconPositionEnd>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu xPosition="before">
        @if ((isStaffApp$ | async) != true) {
          <button mat-flat-button routerLink="settings">
            Settings <mat-icon iconPositionEnd>settings</mat-icon>
          </button>
        }
        @if (showInstallAppButton$ | async) {
          <button mat-flat-button (click)="installApp()">
            Install App <mat-icon iconPositionEnd>download</mat-icon>
          </button>
        }
        <button mat-flat-button (click)="setupPushNotifications()">
          Enable Push Notifications
          <mat-icon iconPositionEnd>notifications</mat-icon>
        </button>

        <button mat-flat-button (click)="logout()">
          Logout <mat-icon iconPositionEnd>logout</mat-icon>
        </button>
        @if (isStaffApp$ | async) {
          <div class="p-1">Version: {{ appVersion }}</div>
        }
      </mat-menu>
    </div>
  </div>
</div>
